/** Companies → company → Contacts: contacts by purpose, with mail and call links. */
export const contactsEn={
 "company.tab.contacts":"Contacts",
 "contacts.intro":"People and lines at {company}, by what they handle. Contact emails also count as known recipients when sending.",
 "contacts.add":"Add contact",
 "contacts.edit":"Edit",
 "contacts.remove":"Remove",
 "contacts.removeConfirm":"Remove {address} from this company’s contacts?",
 "contacts.save":"Save contact",
 "contacts.none":"No contacts yet.",
 "contacts.col.purpose":"Purpose",
 "contacts.col.kind":"Type",
 "contacts.col.address":"Email or number",
 "contacts.col.label":"Name",
 "contacts.kind.email":"Email",
 "contacts.kind.phone":"Phone",
 "contacts.kind.whatsapp":"WhatsApp",
 "contacts.kind.imessage":"iMessage",
 "contacts.purpose.dispatch":"Dispatch",
 "contacts.purpose.billing":"Billing",
 "contacts.purpose.pickup":"Pickup",
 "contacts.purpose.delivery":"Delivery",
 "contacts.purpose.title":"Titles",
 "contacts.purpose.claims":"Claims",
 "contacts.purpose.general":"General",
 "contacts.email":"Email",
 "contacts.call":"Call",
 "contacts.invalid":"Check the email or number for this contact type.",
 "contacts.duplicate":"This company already has that contact for the same purpose.",
 "contacts.conflict":"Someone else changed this contact. The list now shows the latest version.",
 "contacts.saved":"Contact saved.",
 "contacts.removed":"Contact removed.",
 "contacts.readOnly":"Changing contacts needs the “Manage company contacts” permission.",
 "contacts.footer":"Email and Call open your own mail app or phone; MiraOps doesn’t know whether a message arrived or a call connected.",
 "perm.companies.contacts.manage":"Manage company contacts"
};
export const contactsRu:Record<keyof typeof contactsEn,string>={
 "company.tab.contacts":"Контакты",
 "contacts.intro":"Люди и номера в {company} по тому, чем они занимаются. Адреса из контактов также считаются известными получателями при отправке.",
 "contacts.add":"Добавить контакт",
 "contacts.edit":"Изменить",
 "contacts.remove":"Удалить",
 "contacts.removeConfirm":"Удалить {address} из контактов компании?",
 "contacts.save":"Сохранить контакт",
 "contacts.none":"Контактов пока нет.",
 "contacts.col.purpose":"Назначение",
 "contacts.col.kind":"Тип",
 "contacts.col.address":"Почта или номер",
 "contacts.col.label":"Имя",
 "contacts.kind.email":"Почта",
 "contacts.kind.phone":"Телефон",
 "contacts.kind.whatsapp":"WhatsApp",
 "contacts.kind.imessage":"iMessage",
 "contacts.purpose.dispatch":"Диспетчерская",
 "contacts.purpose.billing":"Счета",
 "contacts.purpose.pickup":"Забор",
 "contacts.purpose.delivery":"Доставка",
 "contacts.purpose.title":"Титулы",
 "contacts.purpose.claims":"Претензии",
 "contacts.purpose.general":"Общее",
 "contacts.email":"Написать",
 "contacts.call":"Позвонить",
 "contacts.invalid":"Проверьте адрес или номер для этого типа контакта.",
 "contacts.duplicate":"У компании уже есть такой контакт с тем же назначением.",
 "contacts.conflict":"Контакт изменил кто-то другой. В списке теперь последняя версия.",
 "contacts.saved":"Контакт сохранён.",
 "contacts.removed":"Контакт удалён.",
 "contacts.readOnly":"Для изменения контактов нужно разрешение «Управление контактами компаний».",
 "contacts.footer":"«Написать» и «Позвонить» открывают вашу почту или телефон; MiraOps не знает, дошло ли письмо и состоялся ли звонок.",
 "perm.companies.contacts.manage":"Управление контактами компаний"
};
export const contactsKo:Record<keyof typeof contactsEn,string>={
 "company.tab.contacts":"연락처",
 "contacts.intro":"{company}의 담당 업무별 사람과 번호입니다. 연락처 이메일은 전송 시 알려진 수신자로도 간주됩니다.",
 "contacts.add":"연락처 추가",
 "contacts.edit":"편집",
 "contacts.remove":"삭제",
 "contacts.removeConfirm":"이 회사 연락처에서 {address}을(를) 삭제할까요?",
 "contacts.save":"연락처 저장",
 "contacts.none":"아직 연락처가 없습니다.",
 "contacts.col.purpose":"용도",
 "contacts.col.kind":"유형",
 "contacts.col.address":"이메일 또는 번호",
 "contacts.col.label":"이름",
 "contacts.kind.email":"이메일",
 "contacts.kind.phone":"전화",
 "contacts.kind.whatsapp":"WhatsApp",
 "contacts.kind.imessage":"iMessage",
 "contacts.purpose.dispatch":"배차",
 "contacts.purpose.billing":"청구",
 "contacts.purpose.pickup":"픽업",
 "contacts.purpose.delivery":"배송",
 "contacts.purpose.title":"타이틀",
 "contacts.purpose.claims":"클레임",
 "contacts.purpose.general":"일반",
 "contacts.email":"이메일",
 "contacts.call":"전화",
 "contacts.invalid":"이 연락처 유형에 맞는 이메일 또는 번호인지 확인하세요.",
 "contacts.duplicate":"이 회사에는 같은 용도의 동일한 연락처가 이미 있습니다.",
 "contacts.conflict":"다른 사람이 이 연락처를 변경했습니다. 목록에 최신 버전이 표시됩니다.",
 "contacts.saved":"연락처를 저장했습니다.",
 "contacts.removed":"연락처를 삭제했습니다.",
 "contacts.readOnly":"연락처를 변경하려면 ‘회사 연락처 관리’ 권한이 필요합니다.",
 "contacts.footer":"이메일과 전화는 기기의 메일 앱이나 전화를 엽니다. MiraOps는 메시지 도착이나 통화 연결 여부를 알 수 없습니다.",
 "perm.companies.contacts.manage":"회사 연락처 관리"
};
